import { Component, OnInit } from "@angular/core";
import { NgModel } from "@angular/forms";
import { ActivatedRoute } from "@angular/router";
import { UnsubModel } from "./unsub.model";
import { UnsubService } from "./unsub.service";

@Component({
    styleUrls: ['./unsub.component.css'],
    templateUrl: './unsub.component.html'
})
export class UnsubComponent implements OnInit{

    constructor(private unsubService:  UnsubService,private route: ActivatedRoute) {};


    private _unsubFilter: string = "";
    private _newUnsubName: string = "";
    private _newUnsubDescription: string = "";
    
    public get newUnsubName(): string {
        return this._newUnsubName;
    }
    public set newUnsubName(name: string){
        this._newUnsubName = name;
    }
    public get newUnsubDescription(): string {
        return this._newUnsubDescription;
    }
    public set newUnsubDescription(description: string){
        this._newUnsubDescription = description;
    }
    
    public get unsubFilter(): string{
        return this._unsubFilter;
    }
    public set unsubFilter(filter: string){
        this._unsubFilter = filter;
        this.unsubsFiltered = this.unsubs.filter( unsub => {
            return unsub.name.toLocaleLowerCase().includes(this.unsubFilter.toLocaleLowerCase());
        });        
    }

    unsubs: UnsubModel[] = [];
    unsubsFiltered: UnsubModel[] = [];
    ngOnInit(): void {
        console.log("Killing is ");
        this.unsubFilter = "";
//        this.unsubs = _
        //this.unsubService.getUnsubsAsync().subscribe(unsub => this.unsubs = unsub);
        this.unsubService.getUnsubsNetwork().subscribe(unsub => {
             this.unsubs = unsub;
             this.unsubsFiltered = this.unsubs.filter( unsub => {
                 return unsub.name.toLocaleLowerCase().includes(this.unsubFilter.toLocaleLowerCase());
             });
            
        });     
        //getUnsubsNetwork
    }  
    public addNewUnsub(): void {
        console.log("New unsub requested");
        this.unsubService.addUnsub(new UnsubModel(this.newUnsubName,this.newUnsubDescription,0)).subscribe(unsub => {
            console.log("Success, got response: " + unsub);
            console.dir(unsub);
            this.newUnsubName = "";
            this.newUnsubDescription = "";
            this.unsubs = unsub;
            this.unsubsFiltered = this.unsubs.filter( unsub => {
                return unsub.name.toLocaleLowerCase().includes(this.unsubFilter.toLocaleLowerCase());
            });            
           
       });
    }      
}